'use client';

import React from 'react';
import type { MaterialWithSoftTag } from '../../utils/match-maker.types';
import {
  Caption,
  IconButton,
  List,
  ListItem,
  Separator,
  Status,
} from '@yaradigitallabs/ahua-react';
import { Colors } from '../../../../../public/GlobalTokens';

type MatchedSoftTagsProps = {
  list: Array<MaterialWithSoftTag>;
  onSelect: (item: MaterialWithSoftTag) => void;
};

export const MatchedSoftTagList: React.FC<MatchedSoftTagsProps> = ({
  list,
  onSelect,
}) => {
  return (
    <div className="border border-gray-200 rounded-md">
      <div className="p-4">
        <Caption css={{ color: Colors.colorType.grayscale.contrast }}>
          Click on the card to see the soft tag details.
        </Caption>
      </div>
      <Separator />
      <List>
        <List.Middle className="overflow-y-visible!">
          {(list || [])
            .slice()
            .sort((a, b) => a.priority - b.priority)
            .map(item => (
              <ListItem key={item.id}>
                <ListItem.BodyTail divider>
                  <ListItem.Body
                    role="button"
                    tabIndex={0}
                    onClick={() => onSelect(item)}
                    onKeyDown={e => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        console.log('Selected item:', item);
                        onSelect(item);
                      }
                    }}
                  >
                    <div className="flex flex-row items-center gap-4">
                      <div className="flex flex-row items-center gap-2">
                        <Status size="n" colorType="gray">
                          {item.priority}
                        </Status>
                        {item.priority === 1 && (
                          <Status size="n" colorType="purple">
                            Primary
                          </Status>
                        )}
                      </div>
                      <ListItem.Subtitle>{item.tag_name}</ListItem.Subtitle>
                    </div>
                  </ListItem.Body>
                  <ListItem.Tail>
                    <IconButton
                      icon="ChevronRight"
                      aria-label="See soft tag detail"
                      onClick={() => onSelect(item)}
                    />
                  </ListItem.Tail>
                </ListItem.BodyTail>
              </ListItem>
            ))}
        </List.Middle>
      </List>
    </div>
  );
};
